"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayherePreapproval = void 0;
const Payhere_1 = require("./Payhere");
const utils_1 = require("./utils");
const requiredPreapprovalParams = {
    return_url: 'returnUrl',
    cancel_url: 'cancelUrl',
    notify_url: 'notifyUrl',
    first_name: 'firstName',
    last_name: 'lastName',
    email: 'email',
    phone: 'phone',
    address: 'address',
    city: 'city',
    country: 'country',
    order_id: 'orderId',
    items: 'itemTitle',
    currency: 'currency',
};
class PayherePreapproval extends Payhere_1.Payhere {
    constructor(customer, preappObj, onApprovalError) {
        super();
        this.onApprovalError = (errorMsg) => console.error(errorMsg);
        this._preappObj = preappObj;
        this._customerData = customer;
        this.onApprovalError = onApprovalError;
    }
    async start() {
        try {
            const preappReq = {
                ...this._preappObj.toJSON(),
                ...this._customerData.toJSON(),
            };
            (0, utils_1.submitPayhereClientRequest)(preappReq, requiredPreapprovalParams, '/pay/preapprove', this.onApprovalError);
        }
        catch (err) {
            this.onApprovalError('Unknown error: ' + err);
        }
    }
}
exports.PayherePreapproval = PayherePreapproval;
